import _ from "lodash";
import QueryEmployeeBookingsStatusInvited from "graphql/queries/QueryEmployeeBookingsStatusInvited";
import { constantsActive } from "utils/constants/constants";
import { bookingStatus } from "utils/constants/booking-constants";
import FetchBooking from 'utils/fetch/FetchBooking'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import HelperDate, { dateFormat } from 'utils/helper-date'

const FetchBookingInvitationReceived = {
	
	fetchAll: ( {callbackSuccess = null, callbackError = null, callbackStart = null} = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'invitations_received', QueryEmployeeBookingsStatusInvited, {
			filterResultWithoutGuid: true,
			variables: {
				employee_guid: '::employee_guid',
				booking_date: HelperDate.date().format( dateFormat.DATE + ' 00:00:01' ) + '_after_equal',
				active: [ constantsActive.YES, constantsActive.NO ],
				status: [ bookingStatus.INVITED ]
			},
			resultPath: [ 'employee_bookings' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if ( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( {
						bookings: FetchBooking.process( result ),
					} );
				}
			},
		})
	}
}

export default FetchBookingInvitationReceived
